// import React from "react";
// // import ReactDOM from "react-dom";
// import "antd/dist/antd.css";
// // import "./index.css";
// import { Upload, message, Button } from "antd";
// import AWS from "aws-sdk";
// import { ClockCircleOutlined } from "@ant-design/icons";

// const props = {
//   // multiple: false,
//   // onStart(file) {
//   //   console.log("onStart", file, file.name);
//   // },
//   // onSuccess(ret, file) {
//   //   console.log("onSuccess", ret, file.name);
//   // },
//   // onError(err) {
//   //   console.log("onError", err);
//   // },
//   // onProgress({ percent }, file) {
//   //   console.log("onProgress", `${percent}%`, file.name);
//   // },
//   customRequest({
//     action,
//     data,
//     file,
//     filename,
//     headers,
//     onError,
//     onProgress,
//     onSuccess,
//     withCredentials,
//   }) {
//     AWS.config.update({
//       accessKeyId: "AKIA5L6BGAWSTQFXRNPO",
//       secretAccessKey: "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",
//       region: "ap-southeast-1",
//       sessionToken: "",
//     });

//     const S3 = new AWS.S3();
//     console.log("DEBUG filename", file.name);
//     console.log("DEBUG file type", file.type);
//     let bucketPath = "rider-files/images/" + file.name;
//     const objParams = {
//       Bucket: "krave-rider-sys-bucket",
//       // SourceFile: 'csv-files/rider_messages/',
//       Key: bucketPath,
//       Body: file,
//       ContentType: file.type, // TODO: You should set content-type because AWS SDK will not automatically set file MIME
//     };

//     S3.putObject(objParams)
//       .on("httpUploadProgress", function ({ loaded, total }) {
//         onProgress(
//           {
//             percent: Math.round((loaded / total) * 100),
//           },
//           file
//         );
//       })
//       .send(function (err, data) {
//         console.log("data", data);
//         if (err) {
//           onError();
//           console.log("Something went wrong");
//           console.log(err.code);
//           console.log(err.message);
//         } else {
//           onSuccess(data.response, file);
//           console.log("SEND FINISHED");
//         }
//       });
//   },
// };

// const App = () => {
//   return (
//     <Upload {...props}>
//       <Button>
//         <ClockCircleOutlined type="upload" /> Click to Upload
//       </Button>
//     </Upload>
//   );
// };

// export default App;
export default ""; // for now to remove errors
